'use strict';

export default FormData;



//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/platform/browser/classes/FormData.js
// module id = 326
// module chunks = 0